import React, { Component } from "react";
import MatButton from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";

import Recorder from "./controllerAudio";

export default class Mp3Recorder extends Component {
  state = {
    inicioGravacao: 0,
    gravador: undefined,
    gravandoAudio: false,
    audioGravado: undefined,
    blobURL: null,
    url: "",
    gravou: false,
  };

  descartar = () => {
    this.props.getAudio(undefined);
    // _cleanup();

    this.setState({ gravador: undefined, gravandoAudio: false, blobURL: null });
  };

  _onRecordingComplete = (blob, startGravar) => {
    const fimGravacao = new Date().getTime();

    const tempoAudio = Math.round((fimGravacao - startGravar) / 1000);

    if (this.state.url) {
      window.URL.revokeObjectURL(this.state.url);
    }

    const blobURL = window.URL.createObjectURL(blob);

    this.props.getAudio(blob, blobURL, tempoAudio);

    this.setState({
      url: window.URL.createObjectURL(blob),
      gravador: undefined,
      blobURL,
      tempoAudio,
      gravou: true,
    });
    // });
  };

  _onRecordingError = (err) => {
    console.log("error recording", err);

    if (this.state.url) {
      window.URL.revokeObjectURL(this.state.url);
    }

    this.setState({ url: null });
  };

  render() {
    const { url } = this.state;

    return (
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "inline" }}>
            <Recorder
              onRecordingComplete={this._onRecordingComplete}
              onRecordingError={this._onRecordingError}
              _cleanup={this.descartar}
              style={{
                margin: "0 auto",
              }}
            />
          </div>

          {this.props.recordedAudio && (
            <MatButton
              variant="contained"
              mini
              sx={{ color: "white" }}
              onClick={this.descartar}
            >
              <DeleteIcon />
            </MatButton>
          )}
          {/* {this.props.recordedAudio && <span>Áudio gravado</span>} */}

          {this.props.recordedAudio && <audio src={url} controls />}
        </div>
      </div>
    );
  }
}
